// src/OpenRoleSection.jsx

import React, { useState } from "react";
import ApplicationForm from "./ApplicationForm";

const OpenRoleSection = () => {
    const [isFormOpen, setIsFormOpen] = useState(false);
    const [selectedRole, setSelectedRole] = useState(null);

    const openForm = (role) => {
        setSelectedRole(role);
        setIsFormOpen(true);
    };

    const closeForm = () => {
        setIsFormOpen(false);
        setSelectedRole(null);
    };

    const openRoles = [
        {
            title: "Delphi Developer",
            tags: ["Delphi", "Pascal", "MySQL", "RAD Studio"],
            type: "Full-time",
            level: "Mid-Senior",
            description:
                "Design, develop and maintain Delphi-based applications. Work with databases and integrate various systems while ensuring optimal performance",
            icon: "https://cdn-icons-png.flaticon.com/512/6132/6132222.png",
        },
        {
            title: "Full Stack Developer",
            tags: ["React.js", "JavaScript", "MongoDB", "Node.js"],
            type: "Full-time",
            level: "Mid-Senior",
            description:
                "Design and implement end-to-end web applications using modern frameworks. Develop both frontend and backend components while ensuring scalability and performance",
            icon: "https://cdn-icons-png.flaticon.com/512/1006/1006363.png",
        },
        {
            title: "SQL Developer",
            tags: ["MySQL", "MS SQL Server", "Query Optimization", "ETL"],
            type: "Full-time",
            level: "Mid-Senior",
            description:
                "Design and implement database solutions, write optimized queries, and ensure data integrity. Develop stored procedures and manage database performance",
            icon: "https://cdn-icons-png.flaticon.com/512/4492/4492311.png",
        },
        {
            title: "QA & Automation Tester",
            tags: ["Selenium", "Cypress", "TestNG", "JUnit"],
            type: "Full-time",
            level: "Mid-Senior",
            description:
                "Develop and execute automated test scripts to ensure software quality. Identify bugs and collaborate with developers to resolve issues throughout the SDLC",
            icon: "https://cdn-icons-png.flaticon.com/512/3767/3767088.png",
        },
    ];

    return (
        <div className="bg-gray-50 min-h-screen py-12 px-4 sm:px-6 lg:px-8">
            <div className="max-w-6xl mx-auto">
                {/* Header */}
                <div className="text-center mb-12">
                    <h1 className="text-4xl font-bold text-gray-900 mb-4">
                        Open Roles
                    </h1>
                    <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                        We are on the lookout for dynamic individuals who want to make a
                        difference. Current opportunities include exciting positions across
                        various technology domains.
                    </p>
                </div>

                {/* Roles Grid */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 md:gap-8">
                    {openRoles.map((role, index) => (
                        <div
                            key={index}
                            className="group bg-white rounded-xl shadow-lg p-6 flex flex-col 
                            transition-all duration-300 hover:shadow-blue-100 hover:shadow-xl hover:scale-[1.02]"
                        >
                            {/* Icon + Content */}
                            <div className="flex items-start gap-4 mb-4">
                                {/* Icon */}
                                <div className="w-14 h-14 bg-blue-100 flex items-center justify-center rounded-lg flex-shrink-0">
                                    <img
                                        src={role.icon}
                                        alt={role.title}
                                        className="w-7 h-7 object-contain"
                                    />
                                </div>

                                {/* Text Content */}
                                <div>
                                    {/* Role Type and Level */}
                                    <div className="flex flex-wrap gap-2 mb-2">
                                        <span className="px-3 py-1 bg-blue-100 text-blue-800 text-sm font-medium rounded-full">
                                            {role.type}
                                        </span>
                                        <span className="px-3 py-1 bg-purple-100 text-purple-800 text-sm font-medium rounded-full">
                                            {role.level}
                                        </span>
                                    </div>

                                    {/* Role Title */}
                                    <h2 className="text-xl sm:text-2xl font-bold text-gray-800 mb-2 group-hover:text-[#1C74BB] transition-colors duration-300">
                                        {role.title}
                                    </h2>
                                </div>
                            </div>

                            {/* Tags */}
                            <div className="flex flex-wrap gap-2 mb-4">
                                {role.tags.map((tag, idx) => (
                                    <span
                                        key={idx}
                                        className="px-3 py-1 bg-gray-100 text-gray-700 text-sm font-medium rounded-full"
                                    >
                                        {tag}
                                    </span>
                                ))}
                            </div>

                            {/* Description */}
                            <p className="text-gray-600 text-sm sm:text-base mb-6">
                                {role.description}
                            </p>

                            {/* Apply Button */}
                            <button
                                onClick={() => openForm(role.title)}
                                className="px-6 py-2 border border-blue-600 text-blue-600 font-medium rounded-lg hover:bg-[#1C74BB] hover:text-white transition-colors duration-200 w-full"
                            >
                                Apply Now
                            </button>
                        </div>
                    ))}
                </div>

                {/* Extra Section */}
                <div className="text-center mt-12">
                    <p className="text-gray-700 mb-6 text-base sm:text-lg">
                        Don’t see a role that fits? We’re always looking for exceptional talent
                    </p>
                    <button
                        onClick={() => openForm("General Application")}
                        className="px-6 py-2 bg-gradient-to-r from-blue-500 to-indigo-600 text-white font-medium rounded-lg shadow-md hover:shadow-lg hover:scale-105 transition-transform duration-300"
                    >
                        Submit Your Resume
                    </button>
                </div>
            </div>

            {/* Application Form Modal */}
            <ApplicationForm
                isOpen={isFormOpen}
                onClose={closeForm}
                role={selectedRole}
                openRoles={openRoles}
            />
        </div>
    );
};

export default OpenRoleSection;